function checkForActiveClass() {
    const gmItems = document.querySelectorAll('li.gm-item');
    let hasActiveClass = false;

    gmItems.forEach(li => {
        if (li.classList.contains('gm-active')) {
            hasActiveClass = true;
        }
    });

    return hasActiveClass;
}

function updateOverlay() {
    const overlay = document.querySelector('.overlay');
    if (!overlay) return;

    if (checkForActiveClass()) {
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
    } else {
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
    }
}

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            updateOverlay();
        }
    });
});

const bodyObserver = new MutationObserver(() => {
    observeAllLiElements();
    updateOverlay();
});

// Observe all li.gm-item elements
function observeAllLiElements() {
    const gmItems = document.querySelectorAll('li.gm-item');

    gmItems.forEach(li => {
        observer.observe(li, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
}


document.addEventListener('DOMContentLoaded', () => {
    updateOverlay();

    observeAllLiElements();

    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});

// Export for manual triggering if needed
window.updateOverlay = updateOverlay;